<template>
    <div class="width100">
        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="2"></Aide>

        <h3 class="titreSolu text-center">Carte grise</h3>

        <h3 class="titreSolu text-center" v-if="niveau==1">De quelle remorque s'agit il?</h3>
        <h3 class="titreSolu text-center" v-if="niveau==2">Cliquez sur l'icone PDF pour ouvrir le document de {{ machine.nom }} .</h3>

        <br />
        <div class="d-block text-center" style="height: 50px">
            <div class="row">
                <div class="col-4">
                    <a v-if="carteGrisePdf" :href="carteGrisePdf" download="download" target="_blank">
                        <div v-if="carteGrisePdf" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte grise </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-if="errorsCG.length" class="alert alert-danger text-center" role="alert">
                        <p v-for="(err, key) in errorsCG" :key="key">{{ err }}</p>
                    </div>
                </div>
                <div  class="col-4">
                    <a :href="carteVertePdf" download="download" target="_blank">
                        <div v-if="carteVertePdf" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte verte  </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-if="errorsCV.length" class="alert alert-danger text-center" role="alert">
                        <p v-for="(err, key) in errorsCV" :key="key">{{ err }}</p>
                    </div>
                </div>
                <div  class="col-4">
                    <a :href="carteATPPdf" download="download" target="_blank">
                        <div v-if="carteATPPdf" class="alert alert-success text-center" role="alert">
                            <b class="text-success">Carte ATP  </b><i class="fa-solid fa-file-pdf fa-2x text-danger"></i>
                        </div>
                    </a>
                    <div v-if="errorsATP.length" class="alert alert-danger text-center" role="alert">
                        <p v-for="(err, key) in errorsATP" :key="key">{{ err }}</p>
                    </div>
                </div>
            </div>

        </div>
        <br />
        <br />
        <br />
        <div v-if="niveau == 1 || niveau == 2" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(machine, keyMachine) in listMachine" :key="keyMachine" class="colSolu col-md-12 col-lg-4">
                <div  class="thtab userList col-12 text-center rounded"
                     @click="choixMachine(keyMachine)">
                    {{machine.nom}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "CarteGrise",
        props: ['token', 'site', 'user', 'racine', 'listUser', 'userId', 'userType', 'idUser', 'systemeClient', 'systemeClientId'
            , 'ifAppli'],
        data() {
            return {
                aide: '', errors: [], listMachine: null, choix: 0, niveau: 1, machine: null,carteGrisePdf:null,
                fileName:null,carteVertePdf:null,carteATPPdf:null,errorsCG: [],errorsCV: [],errorsATP: [],
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            getMachines() {
                fetch(this.racine + this.site + 'api/machines?typeMachine=7&systemeClient=' + this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachine = json['hydra:member']
                        }
                    })
                })
            },
            choixMachine(key)
            {
                this.errors = []
                this.errorsCG = []
                this.errorsCV = []
                this.errorsATP = []
                this.machine = this.listMachine[key]
                this.carteGrisePdf = null
                this.carteVertePdf = null
                this.carteATPPdf = null
                this.niveau = 2

                fetch(this.racine + this.site + 'api/get_carte_grise/'+this.machine.id, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)

                    response.json().then(json => {

                        var link = this.site.replace('index.php/', '')
                        if(json.cg == 1) {
                            this.carteGrisePdf = this.racine + link + "carte_grise/CG " + this.machine.nom + ".pdf"
                        }
                        else
                        {
                            this.errorsCG.push("Pas de carte grise.")
                        }

                        if(json.cv == 1) {
                            this.carteVertePdf = this.racine + link + "carte_verte/CV " + this.machine.nom + ".pdf"
                        }
                        else
                        {
                            this.errorsCV.push("Pas de carte verte.")
                        }

                        if(json.atp == 1) {
                            this.carteATPPdf = this.racine + link + "carte_atp/ATP " + this.machine.nom + ".pdf"
                        }
                        else
                        {
                            this.errorsATP.push("Pas de carte ATP.")
                        }
                        if(json.cv == 0 && json.cg == 0 && json.atp == 0) {
                            this.niveau = 1
                        }

                    })
                })
            },
        },
        mounted() {
            this.getMachines()
        }
    }
</script>


<style scoped>
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border: 2px white solid;
        font-size: 28px;
    }

    .listMachineNonCharge {
        font-size: 28px;
    }
</style>